import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

export const RELATIVE_URL = 'system-action-categories';

export const COLUMNS_TO_SHOW_WEB = ['name', 'actions'];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'NOME',
    name: 'name',
    placeholder: 'Insira o nome',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
